import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
import { Button, Col, Input, Row } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import Drawer from 'components/Drawer';
import PoReconciliationDrawerTable from '../PoReconciliationDrawer';
import CancleIcon from "assets/icon/icon-icon-options-not-eligible.svg";
import CancleHoverIcon from "assets/icon/icon-icon-options-not-eligible-hover.svg";
import Loader from 'components/Loader';
import EyeIcon from 'assets/icon/icon-icon-options-view-patient.svg';
import EyeIconHover from 'assets/icon/icon-icon-options-view-patient_hover.svg';

let tableDataBackup = [
    {
        chainPharmacy: "123445",
        pharmacy: "123445",
        npi: "123445",
        ncpdPandNABP: "123445",
        pharmacyAddress: "123445",
        pharmacyLiveDate: "123445",
        pharmacyTerminationDate: "123445",
        claimsProcessDate: "123445",

    }
];
let rowForEdit = {};
let updatedFields = {};
const PoReconciliationTable = (props) => {
    const {
        onPageChange,
        manvalConfigedit,
        manvalConfig,
        manvalPharmacy,
        totalitem,
        data,
        orgId,
        refetch,
        refetch1,
        filters,
        collapseSider,
        toggleSider,
    resetFilterFlag,
    SetResetFilterFlag,tabKey,
        onSearchColumnFilters = () => '',onExport,resetKey
    } = props;

    const [tableData, setTableData] = useState(tableDataBackup);
    const [isPODetailsOpen, setisPODetailsOpen] = useState(false);
    const [drawerPODetails, setDrawerPODetails] = useState('');
    // const [data1, setData] = useState([]);
    const [poRowData, setPORowData] = useState({});

useEffect(()=>{
     setisPODetailsOpen(false);
},[orgId])

    const togglePODetailsDrawer = () => {
        setisPODetailsOpen(!isPODetailsOpen);
        setDrawerPODetails('');
    };
    const handleConfig = async (rowData) => {
        await manvalConfig();

    }
    const handelAddCoveredEntity = async (rowData) => {
        await manvalPharmacy();

    }

    const renderViewButton = (rowData) => {
        //  if (hasPermission('ED'))
        return <Button
            className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={() => handlePODetails(rowData)}
            title='View Order'

        >
                <HoverImage
                    key='EyeIcon'
                    src={EyeIcon}
                    hoverSrc={EyeIconHover}
                    alt=''
                />
        </Button>
    }

    const renderConfigButton = () => {

        return <Button
            className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={() => handleConfig()}
            title='Client Configuration'

        >
            <HoverImage
                src={ConfigIcon}
                hoverSrc={ConfigIconHover}
                alt='' />
        </Button>
    }


    const cellRenderEdit = (rowData) => {
        return (
            <div className='d-flex align-items-center'>
                {renderViewButton(rowData)}
                {/* {renderConfigButton(rowData)} */}
                {/* {renderCommentsButton(rowData)} */}
                {/* {renderViewButton(rowData)} */}
            </div>
        );
    };
    const onHandleSort = (filter, hasColFilter) => {
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            onPageChange(filter);
        }
    };
    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
debugger;
        if (hasColFilter) {
            const colFilterOn = { ...filter, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        onPageChange(filter);
    };

    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {

        if (hasColFilter) {
            const colFilterOn = { ...filter, filters: colChangedFilter };
            onPageChange(colFilterOn, true);
        } else {
            onPageChange(filter);
        }
    };
    const handleFilterCancel = () => {
        refetch(true);
    };
    const handleSearchColumnFilters = (colFilter) => {

        debugger
        for(var x in colFilter){
            if(colFilter[x].filterName == 'totalOrderedPrice'){
                colFilter[x].filterValue = (colFilter[x].filterValue).replace(/,/g,"")   
            }
        }


        if (onSearchColumnFilters) {
            onSearchColumnFilters(colFilter);
            // setColFilters(colFilter);
        }
    };
    let mainCol = [
        {
            dataField: 'edit',
            text: 'Options',
         cellRenderer: (rowData) => cellRenderEdit(rowData),
            width: 120,
            show: true,
            disabled: true,
            hideColFilter: true,
            action: true,
          },
        {
            dataField: 'poid',
            text: 'PO Number',
            sort: true,
            width: 140,
            show: true,
            inputType: 'number',
             hideColFilter: false,
           cellRenderer: (rowData) => cellRendererCheck(rowData.poid),
            // cellRenderer: (rowData) => cellRendererCheck(rowData.poid),
            // action: true,
        },
        {
            dataField: 'filePONumber',
            text: 'Source PO #',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData) => cellRendererCheck(rowData.filePONumber),
        },
        {
            dataField: 'hospitalName',
            text: 'Hospital Name',
            sort: false,
            width: 240,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData) => cellRendererCheck(rowData.hospitalName),
        },
        {
            dataField: 'accountType',
            text: 'Account Type',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData) => cellRendererCheck(rowData.accountType),
        },
        {
            dataField: 'accountCode',
            text: 'Acct #',
            sort: false,
            width: 100,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData) => cellRendererCheck(rowData.accountCode),
        },
        {
            dataField: 'poDate',
            text: 'PO Date',
            sort: true,
            width: 140,
            show: true,
            inputType: 'date',
            hideColFilter: false,
            cellRenderer: (rowData) => dateFormate(rowData.poDate),
        },
        {
            dataField: 'poType',
            text: 'PO Type',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData) => cellRendererCheck(rowData.poType),

        },
        
        {
            dataField: 'poStatusID',
            text: 'PO Status',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rorowDataw) => cellRendererCheck(rorowDataw.poStatusID),
        },
        {
            dataField: 'wholesalerName',
            text: 'Wholesaler Name',
            sort: false,
            width: 220,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rorowDataw) => cellRendererCheck(rorowDataw.wholesalerName),
        },
        {
            dataField: 'totalOrderedPrice',
            text: 'Ordered Price',
            sort: true,
            width: 150,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rorowDataw) => currencyFormat(rorowDataw.totalOrderedPrice),
        },
        {
            dataField: 'createdByID',
            text: 'Created By',
            sort: false,
            width: 100,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData) => cellRendererCheck(rowData.createdByID),
        },
        {
            dataField: 'modifiedByID',
            text: 'Modified By',
            sort: false,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData) => cellRendererCheck(rowData.modifiedByID),
        },

    ];
    const cellRenderLink = (rowData) => {
        // if (hasPermission('VWPO')) {
        return (
            <span
                className='text-decoration-underline d-inline-block cursor-pointer'
                onClick={() => handlePODetails(rowData)}
            >
                {rowData.poid}
            </span>
        );
        // }
    };
    const handlePODetails = (rowData) => {
        setisPODetailsOpen(!isPODetailsOpen);
        setDrawerPODetails('OrderDetails');
        setPORowData(rowData);
    };
    return (
      <div>
        <h5 className="f-16 text-primary font-weight-700 mt-2">
          Reconciliation Count ({totalitem})
        </h5>
        <hr />

        <div
          // className='table-card scroll-table position-relative border-0 rounded pt-0 mt-3'
          // fixed-height={data.length > 0 ? 'fixed-height' : 'default'}
          className="table-card scroll-table position-relative border-0 rounded pt-0"
          fixed-height={
            data.length > 0
              ? `${collapseSider ? "collapse-fixed-height" : "fixed-height"}`
              : "default"
          }
        >
          <ReactStrapTable
            id="configuration-table1"
            height={550}
            fixedColumn
            width={1200}
            data={data}
            columns={mainCol}
            hasPagination
            filters={filters}
            totalRecords={totalitem}
            pageSize={filters.pageSize}
            currentPage={filters.currentPage}
            onExport={onExport}
            handleSort={onHandleSort}
            onPageChange={onHandlePageChange}
            onPageSizeChange={onPageSizeChange}
            onFilterCancel={handleFilterCancel}
            onSearchColumnFilters={handleSearchColumnFilters}
            collapseSider={collapseSider}
            toggleSider={toggleSider}
            showtoggle={true}
            resetFilterFlag={resetFilterFlag}
            SetResetFilterFlag={SetResetFilterFlag}
            keytab={tabKey}
            resetKey={resetKey}
          />
          <Drawer
            direction="end"
            title="Cancel PO Items"
            isOpen={isPODetailsOpen}
            toggle={togglePODetailsDrawer}
            size="lg"
          >
            <PoReconciliationDrawerTable
              refetch={refetch}
              refetch1={refetch1}
              rowData={poRowData}
              orgId={orgId}
              manvalConfigedit={manvalConfigedit}
              togglePODetailsDrawer={togglePODetailsDrawer}
              filters={filters}
              onPageSizeChange={onPageSizeChange}
            />
          </Drawer>
        </div>
      </div>
    );
}

export default PoReconciliationTable
